import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["onAddTeams", "onRemoveTeam", "onAddUsers", "onRemoveUser", "onSetEveryone", "label", "teams", "users", "description", "isLockedToTeam", "emptyAudienceType", "required", "usersType"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import React from 'react';
import { useTranslation } from 'react-i18next';
import FormField from 'components/FormField';
import Button from 'components/Button';
import Pill from 'components/Pill';
import InlineList from 'components/InlineList';
import Box from 'components/Box';
import Flag from 'components/Flag';
import Icon from 'components/Icon';
import Text from 'components/Text';
import TeamsAndUsersList from './common/TeamsAndUsersList';
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
function SelectedAudience(_ref) {
  var emptyAudienceType = _ref.emptyAudienceType,
    description = _ref.description,
    teams = _ref.teams,
    users = _ref.users,
    onRemoveTeam = _ref.onRemoveTeam,
    onRemoveUser = _ref.onRemoveUser;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  if (emptyAudienceType === 'everyone') {
    return /*#__PURE__*/_jsx(Pill, {
      as: "p",
      children: t('state_everyone')
    });
  }
  if (emptyAudienceType === 'none') {
    return /*#__PURE__*/_jsx(Pill, {
      children: t('amount_none')
    });
  }
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [description && /*#__PURE__*/_jsx(Flag, {
      token: /*#__PURE__*/_jsx(Icon, {
        vAlign: true,
        name: "info",
        dimmed: true
      }),
      spacing: "xs",
      my: "xs",
      children: /*#__PURE__*/_jsx(Text, {
        children: description
      })
    }), /*#__PURE__*/_jsx(TeamsAndUsersList, {
      teams: teams,
      users: users,
      onRemoveTeam: onRemoveTeam,
      onRemoveUser: onRemoveUser
    })]
  });
}
function AudienceIncludingUsersField(_ref2) {
  var onAddTeams = _ref2.onAddTeams,
    onRemoveTeam = _ref2.onRemoveTeam,
    onAddUsers = _ref2.onAddUsers,
    onRemoveUser = _ref2.onRemoveUser,
    onSetEveryone = _ref2.onSetEveryone,
    label = _ref2.label,
    teams = _ref2.teams,
    users = _ref2.users,
    description = _ref2.description,
    isLockedToTeam = _ref2.isLockedToTeam,
    emptyAudienceType = _ref2.emptyAudienceType,
    required = _ref2.required,
    _ref2$usersType = _ref2.usersType,
    usersType = _ref2$usersType === void 0 ? 'members' : _ref2$usersType,
    otherProps = _objectWithoutProperties(_ref2, _excluded);
  var _useTranslation2 = useTranslation(),
    t = _useTranslation2.t;
  var teamsButtonLabel = teams.length === 0 ? t('actions_select_teams') : t('actions_edit_teams');
  var memberUsersButtonLabel = users.length === 0 ? t('actions_select_users') : t('actions_edit_users');
  var individualUsersButtonLabel = users.length === 0 ? t('actions_select_individuals') : t('actions_edit_individuals');
  var usersButtonLabel = usersType === 'members' ? memberUsersButtonLabel : individualUsersButtonLabel;
  var teamsButtonIcon = teams.length === 0 ? 'plus' : 'edit';
  var usersButtonIcon = users.length === 0 ? 'plus' : 'edit';
  return /*#__PURE__*/_jsxs(FormField, _objectSpread(_objectSpread({
    as: "fieldset",
    label: label || t('property_audience'),
    required: required
  }, otherProps), {}, {
    children: [/*#__PURE__*/_jsx(SelectedAudience, {
      teams: teams,
      users: users,
      emptyAudienceType: emptyAudienceType,
      description: description,
      onRemoveTeam: onRemoveTeam,
      onRemoveUser: onRemoveUser
    }), /*#__PURE__*/_jsx(Box, {
      mt: "xs",
      children: /*#__PURE__*/_jsxs(InlineList, {
        spacing: "xs",
        top: "xs",
        children: [!isLockedToTeam && /*#__PURE__*/_jsx(Button, {
          icon: teamsButtonIcon,
          onClick: onAddTeams,
          size: "medium",
          children: teamsButtonLabel
        }), /*#__PURE__*/_jsx(Button, {
          icon: usersButtonIcon,
          onClick: onAddUsers,
          size: "medium",
          children: usersButtonLabel
        }), (teams.length !== 0 || users.length !== 0 || emptyAudienceType === 'none') && /*#__PURE__*/_jsx(Button, {
          size: "medium",
          onClick: onSetEveryone,
          children: t('actions_set_audience_to_everyone')
        })]
      })
    })]
  }));
}
export default AudienceIncludingUsersField;